import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./searchBox.css";

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.changeFocus = this.changeFocus.bind(this);
  }

  changeFocus(e) {
    const { name, value } = e.target;
    if (name === "docNumber1") {
      if (value.length === 1) {
        this.docNumber2.focus();
      }
    } else if (name === "docNumber2") {
      if (value.length === 2) {
        this.docNumber3.focus();
      }
    }
  }

  render() {
    const { showLoader } = this.props;
    console.log("InvoiceProps:", this.props);
    //Setting default value to nmsc
    //this.props.data.nmsc = this.props.data.nmsc ? this.props.data.nmsc : this.props.distributors[0].code;
    this.props.data.currency = this.props.data.currency
      ? this.props.data.currency
      : this.props.currencyData[0].value;

    return (
      <form onSubmit={this.props.onSearchHandler} autoComplete="off">
        <div
          className="row contentData"
          style={{ margin: "0.5%", border: "1px solid" }}
        >
          <div
            className="col-md-12 col-sm-12 col-xs-12 form-horizontal"
            style={{ marginTop: "1%" }}
          >
            {this.props.role.includes("EDOC TME USER") ||
            this.props.role.includes("EDOC NMSC USER") ||
            this.props.role.includes("EDOC INVOICE ADMIN") ||
            this.props.role.includes("EDOC TME AF USER") ? (
              <div>
                <div className="form-group row">
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b> Distributor Number</b>
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-8 ">
                      <select
                        className="form-control"
                        name="nmsc"
                        value={this.props.data.nmsc}
                        onChange={this.props.onChangeHandler}
                      >
                        {this.props.distributors.map((ele, key) => {
                          return (
                            <option key={key} value={ele.code}>
                              {ele.displayValue}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Document Number</b>
                    </label>
                    <input
                      className="col-md-1 col-sm-1 col-xs-1 ml-3 mr-2 form-control"
                      maxLength="1"
                      type="text"
                      name="docNumber1"
                      value={this.props.data.docNumber1}
                      onChange={this.props.onChangeHandler}
                      onKeyUp={this.changeFocus}
                    />
                    <input
                      className="col-md-1 col-sm-1 col-xs-1 mr-2 form-control"
                      maxLength="2"
                      type="text"
                      name="docNumber2"
                      ref={(input) => {
                        this.docNumber2 = input;
                      }}
                      value={this.props.data.docNumber2}
                      onChange={this.props.onChangeHandler}
                      onKeyUp={this.changeFocus}
                    />
                    <input
                      className="col-md-3 col-sm-3 col-xs-3 form-control"
                      maxLength="7"
                      type="text"
                      name="docNumber3"
                      ref={(input) => {
                        this.docNumber3 = input;
                      }}
                      value={this.props.data.docNumber3}
                      onChange={this.props.onChangeHandler}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Invoice Date From</b>
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-8">
                      <DatePicker
                        placeholderText="From Date"
                        dateFormat="DD/MM/YYYY"
                        id="fromDate"
                        name="fromDate"
                        selected={
                          this.props.data.fromDate
                            ? Moment(this.props.data.fromDate)
                            : null
                        }
                        onChange={(d) =>
                          this.props.fromDateChangeHandler(d, "fromDate")
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Invoice Date To</b>
                    </label>
                    <div className="col-md-5 col-sm-5 col-xs-5">
                      <DatePicker
                        placeholderText="To Date"
                        dateFormat="DD/MM/YYYY"
                        id="toDate"
                        name="toDate"
                        selected={
                          this.props.data.toDate
                            ? Moment(this.props.data.toDate)
                            : null
                        }
                        onChange={(d) =>
                          this.props.toDateChangeHandler(d, "toDate")
                        }
                        className="form-control"
                      />
                      <p className="text-danger alert-control">
                        {this.props.data.toDateErr}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Amount</b>
                    </label>
                    <div className="col-md-5 col-sm-5 col-xs-5">
                      <input
                        className="form-control"
                        type="text"
                        name="amount"
                        value={this.props.data.amount}
                        onChange={this.props.onChangeHandler}
                      />
                    </div>
                  </div>
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Currency</b>
                    </label>
                    <div className="col-md-5 col-sm-5 col-xs-5">
                      <select
                        className="form-control"
                        name="currency"
                        value={this.props.data.currency}
                        onChange={this.props.onChangeHandler}
                      >
                        {this.props.currencyData.map((ele, key) => {
                          return (
                            <option key={key} value={ele.value}>
                              {ele.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="form-group row">
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Document Number</b>
                    </label>
                    <input
                      className="col-md-1 col-sm-1 col-xs-1 ml-3 mr-2 form-control"
                      maxLength="1"
                      type="text"
                      name="docNumber1"
                      value={this.props.data.docNumber1}
                      onChange={this.props.onChangeHandler}
                      onKeyUp={this.changeFocus}
                    />
                    <input
                      className="col-md-1 col-sm-1 col-xs-1 mr-2 form-control"
                      maxLength="2"
                      type="text"
                      name="docNumber2"
                      ref={(input) => {
                        this.docNumber2 = input;
                      }}
                      value={this.props.data.docNumber2}
                      onChange={this.props.onChangeHandler}
                      onKeyUp={this.changeFocus}
                    />
                    <input
                      className="col-md-3 col-sm-3 col-xs-3 form-control"
                      maxLength="7"
                      type="text"
                      name="docNumber3"
                      ref={(input) => {
                        this.docNumber3 = input;
                      }}
                      value={this.props.data.docNumber3}
                      onChange={this.props.onChangeHandler}
                    />
                  </div>
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Amount</b>
                    </label>
                    <div className="col-md-5 col-sm-5 col-xs-5">
                      <input
                        className="form-control"
                        type="text"
                        name="amount"
                        value={this.props.data.amount}
                        onChange={this.props.onChangeHandler}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Invoice Date From</b>
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-8">
                      <DatePicker
                        placeholderText="From Date"
                        dateFormat="DD/MM/YYYY"
                        id="fromDate"
                        name="fromDate"
                        selected={
                          this.props.data.fromDate
                            ? Moment(this.props.data.fromDate)
                            : null
                        }
                        onChange={(d) =>
                          this.props.fromDateChangeHandler(d, "fromDate")
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Invoice Date To</b>
                    </label>
                    <div className="col-md-5 col-sm-5 col-xs-5">
                      <DatePicker
                        placeholderText="To Date"
                        dateFormat="DD/MM/YYYY"
                        id="toDate"
                        name="toDate"
                        selected={
                          this.props.data.toDate
                            ? Moment(this.props.data.toDate)
                            : null
                        }
                        onChange={(d) =>
                          this.props.toDateChangeHandler(d, "toDate")
                        }
                        className="form-control"
                      />
                      <p className="text-danger alert-control">
                        {this.props.data.toDateErr}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="row col-md-6">
                    <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                      <b>Currency</b>
                    </label>
                    <div className="col-md-5 col-sm-5 col-xs-5">
                      <select
                        className="form-control"
                        name="currency"
                        value={this.props.data.currency}
                        onChange={this.props.onChangeHandler}
                      >
                        {this.props.currencyData.map((ele, key) => {
                          return (
                            <option key={key} value={ele.value}>
                              {ele.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              className="form-group row pull-right"
              style={{ marginLeft: "0.5%" }}
            >
              {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={showLoader}
              >
                <i
                  className="fa fa-spinner fa-spin"
                  style={{
                    display: showLoader ? "inline-block" : "none",
                    marginLeft: "1px",
                  }}
                ></i>
                <i
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{
                    display: !showLoader ? "inline-block" : "none",
                    marginLeft: "1px",
                  }}
                ></i>
                Search
              </button>{" "}
              &nbsp;&nbsp;&nbsp;
              {/* </div> */}
              {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
              <input
                type="button"
                className="btn btn-primary"
                value="Clear"
                onClick={this.props.onResetHandler}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  const showLoader = state.spinner.show;
  return {
    showLoader,
    alert,
  };
}

const connectedLoginPage = connect(mapStateToProps)(SearchBox);
export { connectedLoginPage as SearchBox };
